import React, { useState } from "react";
import styles from "../HealthChat.module.css";

const StarIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="#7C4DFF">
    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
  </svg>
);

export default function PaymentScreen({ onSelect, onBack }) {
  const [selectedMethod, setSelectedMethod] = useState("upi");

  const paymentMethods = [
    {
      id: "upi",
      label: "UPI",
      icons: ["/google-pay.svg", "/phone-pe.svg", "/paytm.svg", "/bhim.svg"],
    },
    {
      id: "card",
      label: "Card",
      icons: ["/visa.svg", "/mastercard.svg", "/rupay.svg"],
    },
    { id: "netbanking", label: "Net Banking", icons: [] },
    { id: "wallets", label: "Wallets", icons: [] },
  ];

  return (
    <div className={styles.bookingWrapper}>
      <button className={styles.paymentBack} onClick={onBack}>
        ← Back
      </button>
      {/* AI Message Bubble */}
      <div className={styles.messageBubbleRow}>
        <img
          src="/images/chatbotFemCare.svg"
          alt="Chatbot"
          width={52}
          height={52}
          className={styles.avatar}
        />
        <div className={styles.messageBubble}>
          Almost done! Please complete your payment to confirm the appointment.
          <span className={styles.timeStamp}>10:33 AM</span>
        </div>
      </div>

      {/* Payment Summary */}
      <div className={styles.paymentSummarySection}>
        <h3 className={styles.sectionTitle}>Payment summary</h3>
        <div className={styles.summaryRow}>
          <span>Consultation fee</span>
          <span>₹800</span>
        </div>
        <div className={styles.summaryRow}>
          <span>Platform fee</span>
          <span>₹0</span>
        </div>
        <div className={styles.summaryDivider} />
        <div className={`${styles.summaryRow} ${styles.totalRow}`}>
          <span>Total amount</span>
          <span>₹800</span>
        </div>
      </div>

      {/* Payment Methods */}
      <div className={styles.methodsSection}>
        <h3 className={styles.sectionTitle}>Choose payment method</h3>
        <div className={styles.methodsList}>
          {paymentMethods.map((method) => (
            <div
              key={method.id}
              className={`${styles.methodItem} ${selectedMethod === method.id ? styles.selectedMethod : ""}`}
              onClick={() => setSelectedMethod(method.id)}
            >
              <div className={styles.methodLeft}>
                <div className={styles.radioCircle}>
                  {selectedMethod === method.id && (
                    <div className={styles.radioInner} />
                  )}
                </div>
                <span className={styles.methodLabel}>{method.label}</span>
              </div>
              <div className={styles.methodIcons}>
                {method.icons.map((icon, idx) => (
                  <div key={idx} className={styles.methodIconPlaceholder} />
                  /* Replace div above with <img src={icon} /> when assets are ready */
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Pay Button */}
      <button className={styles.visitModelContinueBtn} onClick={onSelect}>
        Pay ₹800 securely
      </button>
    </div>
  );
}
